import { useAdminContext } from "@aix/ui"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect } from "react"
import { AdminEmailsPreview } from "~/components/Admin/AdminTools/AdminEmailsPreview"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"
import { api } from "~/utils/api"

function AdminEmail() {
  const { isAdmin } = useAdminContext()
  const navigate = useNavigate()
  const ctx = api.useContext()

  const user = ctx.users.getUserWithTeam.getData()

  useEffect(() => {
    if (!isAdmin) {
      void navigate({ to: "/home" })
    }
  }, [user?.id])

  return (
    <>
      <CustomHead />

      <div>
        <AdminEmailsPreview />
      </div>
    </>
  )
}

function AdminEmailWrapper() {
  return (
    <SuperAdminLayout>
      <AdminEmail />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/email")({
  component: AdminEmailWrapper,
})
